import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { CamVardiyaEditComponent } from './cam-vardiya-edit.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

const VARDIYA_RENK: Record<string, string> = { 'Sabah': '#faad14', 'Öğle': '#fa8c16', 'Gece': '#722ed1' };
const VARDIYA_RGB: Record<string, string> = { 'Sabah': '250,173,20', 'Öğle': '250,140,22', 'Gece': '114,46,209' };
const VARDIYA_EMOJI: Record<string, string> = { 'Sabah': '🌅', 'Öğle': '☀️', 'Gece': '🌙' };

@Component({
  selector: 'cam-vardiya-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-vardiya" [style.--accent]="renk()" [style.--accent-rgb]="rgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">⏰ VARDİYA KAYDI</div>
        <div class="vd-vardiya" [style.background]="'rgba('+rgb()+',.15)'" [style.color]="renk()">{{ emoji() }} {{ vardiyaTuru() }}</div>
        <div class="gc-stat-bolge">
          <div class="gc-stat-satir">
            <span class="gc-stat-isim">ÜRETİM</span>
            <span class="gc-stat-deger gc-stat-deger--yesil">{{ d('uretimAdedi') || 0 }}</span>
          </div>
          <div class="gc-stat-satir">
            <span class="gc-stat-isim">RED</span>
            <span class="gc-stat-deger gc-stat-deger--kirmizi">{{ d('redAdedi') || 0 }}</span>
          </div>
          @if (verimlilik() !== null) {
            <div class="gc-stat-satir">
              <span class="gc-stat-isim">VERİMLİLİK</span>
              <div class="gc-stat-bar">
                <div class="gc-stat-bar-dolgu" [class.gc-stat-bar--yesil]="verimlilik()! >= 90" [class.gc-stat-bar--sari]="verimlilik()! >= 70 && verimlilik()! < 90" [class.gc-stat-bar--kirmizi]="verimlilik()! < 70" [style.width.%]="gorunur() ? verimlilik() : 0"></div>
              </div>
              <span class="gc-stat-deger" [class.gc-stat-deger--yesil]="verimlilik()! >= 90" [class.gc-stat-deger--sari]="verimlilik()! >= 70 && verimlilik()! < 90" [class.gc-stat-deger--kirmizi]="verimlilik()! < 70">%{{ verimlilik() }}</span>
            </div>
          }
        </div>
        @if (d('operator')) { <div class="vd-alt">{{ d('operator') }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? (verimlilik() ?? 10) : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .vd-vardiya { display: inline-block; padding: 3px 12px; border-radius: 4px; font-size: 11px; font-weight: 800; letter-spacing: .06em; margin-top: 4px; }
    .vd-alt { font-size: 11px; color: var(--py-metin-ikincil, #94a3b8); margin-top: 4px; }
  `],
})
export class CamVardiyaKartComponent extends GameCardBase {
  parametreler = input<any>();
  _hesap = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  vardiyaTuru = computed(() => this.d('vardiyaTuru') || 'Sabah');
  renk = computed(() => VARDIYA_RENK[this.vardiyaTuru()] || '#fa8c16');
  rgb = computed(() => VARDIYA_RGB[this.vardiyaTuru()] || '250,140,22');
  emoji = computed(() => VARDIYA_EMOJI[this.vardiyaTuru()] || '⏰');
  verimlilik = computed(() => {
    const uretim = +(this.d('uretimAdedi') || 0);
    const red = +(this.d('redAdedi') || 0);
    if (!uretim) return null;
    return Math.round(((uretim - red) / uretim) * 100);
  });
}

@Component({
  selector: 'cam-vardiya-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#fa8c16">
      <div class="sk-icerik">
        <div class="sk-baslik">⏰ {{ d('vardiyaTuru') || 'Vardiya' }}</div>
        @if (d('operator')) { <div class="sk-alt">{{ d('operator') }}</div> }
      </div>
      <div class="sk-sag">
        <span style="font-size:12px;font-weight:600;color:var(--py-metin,#333)">{{ d('uretimAdedi') || 0 }} üretim</span>
        @if (verimlilik() !== null) { <span class="sk-chip" [style.border-color]="verimlilik()! >= 90 ? '#52c41a' : verimlilik()! >= 70 ? '#d48806' : '#ff4d4f'" [style.color]="verimlilik()! >= 90 ? '#52c41a' : verimlilik()! >= 70 ? '#d48806' : '#ff4d4f'">%{{ verimlilik() }}</span> }
      </div>
    </div>
  `,
})
export class CamVardiyaKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  verimlilik = computed(() => {
    const uretim = +(this.d('uretimAdedi') || 0);
    const red = +(this.d('redAdedi') || 0);
    if (!uretim) return null;
    return Math.round(((uretim - red) / uretim) * 100);
  });
}

@DinamikBilesen({
  id: 'cam-vardiya',
  baslik: 'Vardiya Kaydı',
  aciklama: 'Vardiya üretim ve devir kaydı',
  ikon: 'clock-circle',
  kategori: 'cam-isleme',
})
class CamVardiya {
  paylas_kutusu = CamVardiyaEditComponent;
  paylasilmis_kart = CamVardiyaKartComponent;
  paylasilmis_kart_sade = CamVardiyaKartSadeComponent;
}
